import { Fragment } from 'react';

function boldSegments(line, keyPrefix) {
  return line.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((segment, index) => {
    const key = `${keyPrefix}-${index}`;
    if (segment.startsWith('**') && segment.endsWith('**')) {
      return <strong key={key}>{segment.slice(2, -2)}</strong>;
    }
    return <Fragment key={key}>{segment}</Fragment>;
  });
}

export function SafeFormattedText({ text = '', className = '' }) {
  const paragraphs = String(text).replace(/\r\n?/g, '\n').split(/\n{2,}/);

  return (
    <div className={className}>
      {paragraphs.map((paragraph, paragraphIndex) => (
        <p key={`paragraph-${paragraphIndex}`}>
          {paragraph.split('\n').map((line, lineIndex) => (
            <Fragment key={`line-${lineIndex}`}>
              {lineIndex > 0 && <br />}
              {boldSegments(line, `segment-${paragraphIndex}-${lineIndex}`)}
            </Fragment>
          ))}
        </p>
      ))}
    </div>
  );
}
